
import SWITCH_ENV from './switch_env'

/**===================本地环境====================*/
const BD_ENV = {
    API_URL: 'http://192.180.2.117:8090/',
};

/**===================生产环境====================*/
const SC_ENV = {
    API_URL: 'http://192.170.2.151:13140/'
};

var ENV = {};

switch (SWITCH_ENV) {
    case 'BD':
        ENV = BD_ENV;
        break;
    case 'CS':
        ENV = '';
        break;
    case 'ZSC':
        ENV = '';
        break;
    case 'SC':
        ENV = SC_ENV;
        break;
}

export default ENV;



// WEBPACK FOOTER //
// ./src/assets/config/index.js